import { ClockCountdownIcon } from '@phosphor-icons/react';
import type { ComponentProps } from 'react';

import { Trans } from '@lingui/react/macro';
import { Checkmark, X } from '@remarkable/ark-icons';
import { Tag } from '@remarkable/ark-web';

import type {
  Subscription,
  SubscriptionStatus,
} from 'src/api/endpoints/storeApi.types';
import { subscriptionHelpers } from 'src/utils/subscriptionHelpers';

type StatusTagProps = Partial<ComponentProps<typeof Tag>> & {
  status?: SubscriptionStatus;
  subscription?: Subscription;
};
export const StatusTag = ({
  status,
  subscription,
  ...props
}: StatusTagProps) => {
  const subscriptionStatus =
    status ?? subscriptionHelpers.getStatus(subscription);

  if (!subscriptionStatus) {
    return null;
  }

  switch (subscriptionStatus) {
    case 'Active':
      return (
        <Tag variant="success-light" {...props}>
          <Checkmark /> <Trans>Active</Trans>
        </Tag>
      );
    case 'Trialing':
      return (
        <Tag variant="success-light" {...props}>
          <Checkmark /> <Trans>Trial</Trans>
        </Tag>
      );

    case 'Cancelled':
      return (
        <Tag variant="themed-filled" className="!bg-error-light" {...props}>
          <X /> <Trans>Cancelled</Trans>
        </Tag>
      );
    case 'Deactivated':
      return (
        <Tag {...props}>
          <ClockCountdownIcon /> <Trans>On hold</Trans>
        </Tag>
      );
    default:
      return null;
  }
};
